export default __webpack_public_path__ + "static/media/Test.a77e59c0.svg";